'use strict'

//
// Actions constants
//

export const ToggleNavBar = 'toggleNavBar'
export const UpdateCurrentUser = 'updateCurrentUser'
export const SetLang = 'setLang'
